import { Link } from "react-router-dom";
import { Plus, Settings } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminFab() {
  const { user } = useAuth();
  if (!user || user.role !== "admin") return null;
  return (
    <Link
      to="/admin"
      data-testid="admin-fab"
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 bg-[#e8478e] hover:bg-[#c93875] text-white font-bold uppercase tracking-[0.18em] text-[11px] px-5 py-3.5 rounded-full shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
      title="Manage products"
    >
      <Settings size={14}/> Admin
      <span className="hidden sm:inline-flex items-center gap-1 pl-2 border-l border-white/40 ml-1">
        <Plus size={14}/> Add
      </span>
    </Link>
  );
}
